import type { ComponentProps } from 'react';

import { PageGridItem } from 'corgi/common/components/PageGrid';
import LoginBackToLink from 'corgi/login-back-to-link/components/LoginBackToLink';

import type { LoginBackToLinkProps } from '@local-types/signup/props';

export const BackToLinkGridItem = ({
  loginBackToLinkProps,
  styles,
}: {
  loginBackToLinkProps?: LoginBackToLinkProps;
  styles?: ComponentProps<typeof PageGridItem>;
}) => (
  <PageGridItem
    width={1}
    justifyContent="center"
    textAlign="center"
    px={['sp_16', 'sp_24']}
    mt={['sp_16', 'sp_20', 'sp_24', 'sp_32']}
    {...styles}
  >
    <LoginBackToLink {...loginBackToLinkProps} />
  </PageGridItem>
);
